import { formatSolPrice } from "./economyAmounts";

/** Grouped player-facing SOL; accounting and settlement retain exact lamports. */
export function formatSolLamports(value: string): string {
  if (!isLamports(value)) throw new Error("crew_sol_lamports_invalid");
  const [whole, fraction] = formatSolPrice(value).split(".");
  return `${whole!.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}${fraction ? `.${fraction}` : ""}`;
}
export function estimatedSolDistributable(gross: string): string {
  if (!isLamports(gross)) throw new Error("crew_sol_lamports_invalid");
  const amount = BigInt(gross);
  return (amount > 1_000_000_000n ? amount - 1_000_000_000n : 0n).toString();
}

export function isLamports(value: unknown): value is string {
  return typeof value === "string" && /^(0|[1-9][0-9]*)$/.test(value) && BigInt(value) <= (1n << 64n) - 1n;
}
